"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationsTypes = void 0;
var React = __importStar(require("react"));
var Styled = __importStar(require("./ToastStyles"));
var react_feather_1 = require("react-feather");
var button_1 = __importDefault(require("../button"));
var notificationsTypes;
(function (notificationsTypes) {
    notificationsTypes["ERROR"] = "error";
    notificationsTypes["INFO"] = "info";
    notificationsTypes["SUCCESS"] = "success";
    notificationsTypes["WARNING"] = "warning";
})(notificationsTypes = exports.notificationsTypes || (exports.notificationsTypes = {}));
var Toast = function (_a) {
    var type = _a.type, message = _a.message, handleClose = _a.handleClose, showCloseButton = _a.showCloseButton, action = _a.action;
    var handleActionClick = function () {
        if (action) {
            action.onClick();
            handleClose();
        }
    };
    return (React.createElement(Styled.Toast, null,
        React.createElement(Styled.ToastIndicator, { type: type },
            type === notificationsTypes.SUCCESS && React.createElement(react_feather_1.Check, { size: 16 }),
            type === notificationsTypes.WARNING && React.createElement(react_feather_1.AlertTriangle, { size: 16 }),
            type === notificationsTypes.ERROR && React.createElement(react_feather_1.AlertOctagon, { size: 16 }),
            type === notificationsTypes.INFO && React.createElement(react_feather_1.Info, { size: 16 })),
        React.createElement(Styled.ToastMain, { type: type },
            React.createElement(Styled.ToastContent, { type: type },
                message,
                action && (React.createElement(Styled.ToastButtonContainer, null,
                    React.createElement(button_1.default, { variant: "subtle-black", toastInline: true, size: "small", onClick: handleActionClick }, action.buttonLabel)))),
            showCloseButton && (React.createElement(Styled.ToastCloseContainer, { type: type },
                React.createElement(Styled.ToastClose, { type: type, onClick: function () { return handleClose(); } },
                    React.createElement(react_feather_1.X, { size: 16 })))))));
};
exports.default = Toast;
